class QuantityRadioGroup extends HTMLElement {
  constructor() {
    super();

    this.radios = Array.from(
      this.querySelectorAll("[data-quantity-radio-group-input]"),
    );

    const params = new URLSearchParams(location.search);
    const quantity = params.get("quantity");

    if (quantity) {
      this.radios.forEach((radio) => {
        if (radio.value === quantity) {
          radio.checked = true;
        }
      });
    }
  }
}

customElements.define("quantity-radio-group", QuantityRadioGroup);
